import React, { useState } from 'react'
import Style from './Product.module.css'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import con1 from '../img/con1.png'
import con2 from '../img/con2.png'
import con3 from '../img/con3.png'
import con4 from '../img/con4.png'
import con5 from '../img/con5.png'
import con6 from '../img/con6.png'
import con7 from '../img/con7.png'
import con8 from '../img/con8.png'
import con9 from '../img/con9.png'
import con10 from '../img/con10.png'
import con11 from '../img/con11.png'
import con12 from '../img/con12.png'
import con13 from '../img/con13.png'
import con14 from '../img/con14.png'
import con15 from '../img/con15.png'
import con16 from '../img/con16.png'
import con17 from '../img/con17.png'
import con18 from '../img/con18.png'
import con19 from '../img/con19.png'
import con20 from '../img/con20.png'
import con21 from '../img/con21.png'
import con22 from '../img/th.jpg'
import con23 from '../img/th (1).jpg'
import con24 from '../img/con24.png'
import con25 from '../img/con25.png'
import con26 from '../img/con26.png'
import con27 from '../img/con27.png'
import con28 from '../img/con28.png'


const Product = () => {




    const [Card, SetCard] = useState([
        {
            photos: con1,

        },
        {
            photos: con2
        },
       
        {
            photos: con3,
        },
        {
            photos: con4,
        },
        {
            photos: con5,
        },
        {
            photos: con6,
        },
        {
            photos: con7,
        },
        {
            photos: con8,
        },
        {
            photos: con9,
        },
        {
            photos: con10,
        },
        {
            photos: con11,
        },
        {
            photos: con12,
        },
        {
            photos: con13,
        },
        {
            photos: con14,
        },
        {
            photos: con15,
        },
        {
            photos: con16,
        },
        {
            photos: con17,
        },
        {
            photos: con18,
        },
        {
            photos: con19,
        },
        {
            photos: con20,
        },
        {
            photos: con21,
        },
        {
            photos: con22,
        },
        {
            photos: con23,
        },
        {
            photos: con24,
        },
        {
            photos: con25,
        },
        {
            photos: con26,
        },
        {
            photos: con27,
        },
        {
            photos: con28,
        },





    ])
    return (

        <>
            <div className={ Style.main }>
             
           {/* <Container> */}

                    <Row >
                        {
                            Card.map((box, index) => {
                                return (
                                    <Col key={ index } sm={ 12 } md={ 8 } lg={ 3 }  >

                                        <center >
                                            <div className={ Style.cons }>

                                                <img src={ box.photos } alt="" />

                                            </div>
                                            <h3>{ box.name }</h3>
                                            <p className={ Style.kdj }>{ box.bio } </p>
                                            {/* <Link to={ "/product" } className={ Style.readmore } >readmore</Link> */ }
                                        </center>
                                    </Col>
                                )
                            })
                        }

                    </Row>
           {/* </Container> */}
            </div>

        </>
    )
}

export default Product
